<a [routerLink]="[route()]" class="navbar-item flex gap-2"
   [class.navbar-active-item]="isCurrentPageHref(route())">
  <span class="flex items-center justify-center flex-shrink-0">
    <ng-content select="[icon]"></ng-content>
  </span>
  <span class="whitespace-nowrap">{{ title() }}</span>
</a>
